import React from 'react'
import { Link } from 'react-router-dom'
import PageHeader from '../components/PageHeader'

function About() {
    return (
        <>
            <PageHeader title="About Us" />

            {/* About Us Section */}
            <div className="about-us">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="about-us-images">
                                <div className="about-img-1">
                                    <figure className="image-anime reveal">
                                        <img
                                            src={`${process.env.PUBLIC_URL}/images/about-img-1.jpg`}
                                            alt="Our team"
                                        />
                                    </figure>
                                </div>
                                <div className="about-img-2">
                                    <figure className="image-anime reveal">
                                        <img
                                            src={`${process.env.PUBLIC_URL}/images/about-img-2.jpg`}
                                            alt="Client meeting"
                                        />
                                    </figure>
                                </div>
                                <div className="contact-circle">
                                    <img
                                        src={`${process.env.PUBLIC_URL}/images/contact-us-img.svg`}
                                        alt=""
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="about-us-content">
                                <div className="section-title">
                                    <h3 className="wow fadeInUp">who we are</h3>
                                    <h2 className="text-anime-style-2">
                                        Empowering Nigerians through{' '}
                                        <span>
                                            innovative financial solutions
                                        </span>
                                    </h2>
                                    <p
                                        className="wow fadeInUp"
                                        data-wow-delay="0.2s"
                                    >
                                        We are a leading financial services
                                        provider in Nigeria, dedicated to
                                        empowering individuals and businesses
                                        through innovative solutions tailored to
                                        the Nigerian market. Founded with a
                                        vision to foster financial inclusion and
                                        community-driven prosperity, we offer a
                                        seamless online co-operative platform,
                                        accessible micro-lending services,
                                        expert tax consulting, and professional
                                        financial reporting and analysis.
                                    </p>
                                    <p
                                        className="wow fadeInUp"
                                        data-wow-delay="0.3s"
                                    >
                                        All our services are designed to help
                                        our clients achieve financial success
                                        while adhering to Nigeria's regulatory
                                        frameworks, including the Co-operative
                                        Societies Act and CBN guidelines.
                                    </p>
                                </div>
                                <div className="about-content-body">
                                    <div className="row align-items-center">
                                        <div className="col-md-6">
                                            <div className="about-content-info">
                                                <div
                                                    className="about-goal-box wow fadeInUp"
                                                    data-wow-delay="0.4s"
                                                >
                                                    <div className="icon-box">
                                                        <img
                                                            src={`${process.env.PUBLIC_URL}/images/icon-financial-strategies.svg`}
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="about-goal-box-content">
                                                        <h3>Our Mission</h3>
                                                        <p>
                                                            To bridge the gap
                                                            between opportunity
                                                            and achievement by
                                                            providing
                                                            affordable,
                                                            transparent, and
                                                            technology-driven
                                                            financial services.
                                                        </p>
                                                    </div>
                                                </div>
                                                <div
                                                    className="about-contact-box wow fadeInUp"
                                                    data-wow-delay="0.6s"
                                                >
                                                    <div className="icon-box">
                                                        <img
                                                            src={`${process.env.PUBLIC_URL}/images/icon-phone.svg`}
                                                            alt=""
                                                        />
                                                    </div>
                                                    <div className="about-contact-content">
                                                        <p>
                                                            <a href="tel:+234 705 803 0389">
                                                                +234 705 803
                                                                0389
                                                            </a>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div
                                                className="about-author-box wow fadeInUp"
                                                data-wow-delay="0.4s"
                                            >
                                                <div className="about-info-list">
                                                    <ul>
                                                        <li>
                                                            Financial Inclusion
                                                        </li>
                                                        <li>
                                                            Regulatory
                                                            Compliance
                                                        </li>
                                                        <li>24/7 Support</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Our Approach Section */}
            <div className="our-approach">
                <div className="container">
                    <div className="row section-row align-items-center">
                        <div className="col-lg-6">
                            <div className="section-title">
                                <h3 className="wow fadeInUp">our approach</h3>
                                <h2
                                    className="wow fadeInUp"
                                    data-wow-delay="0.2s"
                                >
                                    Customized strategies for{' '}
                                    <span>Nigerian financial success</span>
                                </h2>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div
                                className="section-btn wow fadeInUp"
                                data-wow-delay="0.2s"
                            >
                                <Link to="/contact" className="btn-default">
                                    Contact now
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {[
                            {
                                icon: 'icon-our-mission.svg',
                                title: 'Our Vision',
                                desc: 'We envision a Nigeria where every individual and business has the opportunity to thrive financially through collaborative, transparent, and innovative solutions.',
                                img: 'our-mission-img.jpg',
                            },
                            {
                                icon: 'icon-our-vision.svg',
                                title: 'Our Mission',
                                desc: 'To bridge the gap between opportunity and achievement by providing affordable, transparent, and technology-driven financial services.',
                                img: 'our-vision-img.jpg',
                            },
                            {
                                icon: 'icon-our-value.svg',
                                title: 'Our Values',
                                desc: 'Transparency, Innovation, Inclusivity, and Regulatory Compliance guide everything we do to serve the Nigerian market.',
                                img: 'our-value-img.jpg',
                            },
                        ].map((item, idx) => (
                            <div className="col-lg-4 col-md-6" key={idx}>
                                <div
                                    className="mission-vission-item wow fadeInUp"
                                    data-wow-delay={`${idx * 0.2}s`}
                                >
                                    <div className="mission-vission-header">
                                        <div className="icon-box">
                                            <img
                                                src={`${process.env.PUBLIC_URL}/images/${item.icon}`}
                                                alt=""
                                            />
                                        </div>
                                        <div className="mission-vission-content">
                                            <h3>{item.title}</h3>
                                            <p>{item.desc}</p>
                                        </div>
                                    </div>
                                    <div className="mission-vission-image">
                                        <figure className="image-anime">
                                            <img
                                                src={`${process.env.PUBLIC_URL}/images/${item.img}`}
                                                alt=""
                                            />
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Why Choose Us Section */}
            <div className="why-choose-us">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="why-choose-content">
                                <div className="section-title">
                                    <h3 className="wow fadeInUp">
                                        what we offer
                                    </h3>
                                    <h2
                                        className="text-anime-style-2"
                                        data-cursor="-opaque"
                                    >
                                        Comprehensive financial services{' '}
                                        <span>for Nigerians</span>
                                    </h2>
                                </div>
                                <div className="why-choose-box-list">
                                    <div
                                        className="why-choose-box wow fadeInUp"
                                        data-wow-delay="0.2s"
                                    >
                                        <div className="icon-box">
                                            <img
                                                src={`${process.env.PUBLIC_URL}/images/icon-why-choose-1.svg`}
                                                alt=""
                                            />
                                        </div>
                                        <div className="why-choose-box-content">
                                            <h3>
                                                Online Co-operative Platform
                                            </h3>
                                            <p>
                                                Join our vibrant community with
                                                contributions from ₦5,000
                                                monthly, access loans at 8%
                                                p.a., and earn dividends.
                                            </p>
                                        </div>
                                    </div>
                                    <div
                                        className="why-choose-box wow fadeInUp"
                                        data-wow-delay="0.4s"
                                    >
                                        <div className="icon-box">
                                            <img
                                                src={`${process.env.PUBLIC_URL}/images/icon-why-choose-2.svg`}
                                                alt=""
                                            />
                                        </div>
                                        <div className="why-choose-box-content">
                                            <h3>Micro-Lending Services</h3>
                                            <p>
                                                Secure fast, affordable loans
                                                (₦50,000–₦5,000,000) with rates
                                                from 10% p.a., processed within
                                                24-48 hours.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className="why-choose-list wow fadeInUp"
                                    data-wow-delay="0.6s"
                                >
                                    <ul>
                                        <li>Tax Consulting &amp; Compliance</li>
                                        <li>
                                            Financial Reporting &amp; Analysis
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="why-choose-image">
                                <div className="why-choose-img-1">
                                    <figure className="image-anime reveal">
                                        <img
                                            src={`${process.env.PUBLIC_URL}/images/why-choose-img-1.jpg`}
                                            alt=""
                                        />
                                    </figure>
                                </div>
                                <div className="why-choose-contact-circle">
                                    <img
                                        src={`${process.env.PUBLIC_URL}/images/contact-us-img.svg`}
                                        alt=""
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Features Section */}
            <div className="our-feature">
                <div className="container">
                    <div className="row section-row align-items-center">
                        <div className="col-lg-6">
                            <div className="section-title dark-section">
                                <h3 className="wow fadeInUp">why choose us</h3>
                                <h2
                                    className="text-anime-style-2"
                                    data-cursor="-opaque"
                                >
                                    Key advantages of our{' '}
                                    <span>Nigerian financial services</span>
                                </h2>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div
                                className="section-btn wow fadeInUp"
                                data-wow-delay="0.2s"
                            >
                                <Link to="/contact" className="btn-default">
                                    contact now
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="our-feature-list">
                                {[
                                    {
                                        icon: 'icon-our-feature-1.svg',
                                        title: 'Local Expertise, Global Standards',
                                        desc: "Our team of certified professionals combines deep knowledge of Nigeria's financial landscape with international best practices.",
                                    },
                                    {
                                        icon: 'icon-our-feature-2.svg',
                                        title: 'Commitment to Inclusion',
                                        desc: "We prioritize underserved communities, supporting Nigeria's financial inclusion goals by offering accessible services.",
                                    },
                                    {
                                        icon: 'icon-our-feature-3.svg',
                                        title: 'Technology-Driven Solutions',
                                        desc: 'Our user-friendly app and website provide 24/7 access to your accounts, secured with bank-grade encryption.',
                                    },
                                    {
                                        icon: 'icon-our-feature-4.svg',
                                        title: 'Transparency and Trust',
                                        desc: 'We adhere to strict regulatory standards, including CBN, FCCPC, and FRC guidelines.',
                                    },
                                    {
                                        icon: 'icon-our-feature-5.svg',
                                        title: 'Community Impact',
                                        desc: "By supporting local projects and empowering members, we contribute to Nigeria's economic growth.",
                                    },
                                    {
                                        icon: 'icon-our-feature-6.svg',
                                        title: 'Regulatory Compliance',
                                        desc: 'All our services strictly adhere to Nigerian regulations including Co-operative Societies Act, CBN guidelines.',
                                    },
                                ].map((feature, idx) => (
                                    <div
                                        className="our-feature-item wow fadeInUp"
                                        data-wow-delay={`${idx * 0.2}s`}
                                        key={idx}
                                    >
                                        <div className="icon-box">
                                            <img
                                                src={`${process.env.PUBLIC_URL}/images/${feature.icon}`}
                                                alt=""
                                            />
                                        </div>
                                        <div className="feature-item-content">
                                            <h3>{feature.title}</h3>
                                            <p>{feature.desc}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Process Section */}
            <div className="our-process-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="section-title">
                                <h2 className="text-anime-style-2">
                                    Our Process for Financial Success
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="process-content wow fadeInUp">
                                <p>
                                    Join our online co-operative platform by
                                    registering with your NIN and BVN to
                                    contribute, access low-interest loans, and
                                    earn incentives; apply for micro-loans with
                                    quick approval; receive expert tax
                                    consulting; and get IFRS-standard financial
                                    reports.
                                </p>
                                <div className="process-steps">
                                    <div className="process-step">
                                        <h4>1. Co-operative Registration</h4>
                                        <p>
                                            Register with NIN and BVN for secure
                                            access to our platform
                                        </p>
                                    </div>
                                    <div className="process-step">
                                        <h4>2. Micro-Loan Access</h4>
                                        <p>
                                            Apply for ₦50,000–₦5,000,000 loans
                                            with quick approval
                                        </p>
                                    </div>
                                    <div className="process-step">
                                        <h4>3. Tax Compliance</h4>
                                        <p>
                                            Expert consulting with
                                            FIRS-compliant filings
                                        </p>
                                    </div>
                                    <div className="process-step">
                                        <h4>4. Financial Reporting</h4>
                                        <p>
                                            IFRS-standard reports and analytics
                                            for strategic growth
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Partners Section */}
            <div className="our-partners">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="our-partners-list">
                                {[1, 2, 3, 4].map((num, idx) => (
                                    <div
                                        className="our-partner-item wow fadeInUp"
                                        data-wow-delay={`${idx * 0.2}s`}
                                        key={idx}
                                    >
                                        <img
                                            src={`${process.env.PUBLIC_URL}/images/our-partner-${num}.svg`}
                                            alt=""
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default About
